import { render, staticRenderFns } from "./ProjectLiveTalk.vue?vue&type=template&id=06e2272d&"
import script from "./ProjectLiveTalk.vue?vue&type=script&lang=ts&"
export * from "./ProjectLiveTalk.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports